<div class="no-items-content">
    <div class="no-items-alert" *ngIf="!config.hiddenWithoutItemMessage">
        <p>{{config.withoutItemMessage}}</p>
    </div>
    <div *ngIf="!config.hiddenBtnAdd">
        <button type="button" mat-stroked-button [matMenuTriggerFor]="menu" color="primary">
            <mat-icon>add</mat-icon>
            {{config.btnAddMessage}}
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="add('object')">Objeto</button>
            <button mat-menu-item (click)="add('array')">Array</button>
            <button mat-menu-item (click)="add('item')">Valor</button>
        </mat-menu>
    </div>
</div>
